import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import { SiWaze } from "react-icons/si";
import { useTranslation } from "react-i18next";
import logoFooter from "../../pages/assets/DreamOnF.png";
import "./Footer.css";

/* Ubicaciones */
import { locations } from "../../common/location";

const toTelHref = (phone) => `tel:${(phone || "").replace(/\s+/g, "")}`;
const wazeFrom = (loc) =>
  loc?.waze
    ? loc.waze
    : `https://waze.com/ul?ll=${loc?.position?.lat},${loc?.position?.lng}&navigate=yes`;

const Footer = () => {
  const { t } = useTranslation();

  const facebookUrl = "https://www.facebook.com/";
  const instagramUrl = "https://www.instagram.com/";
  const whatsappUrl =
    "https://wa.me/50664665874?text=¡Hola!%20Vengo%20del%20sitio%20Dream%20On%20y%20quisiera%20más%20información.";

  const email = "rsantamaria@gruposantamaria.cr";
  const phone = "+506 6466 5874";
  const country = t("footer.contact.country");

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <img
              src={logoFooter}
              alt={t("footer.brand.logoAlt")}
              className="footer__logo"
              width="140"
              height="64"
              loading="eager"
              decoding="async"
            />

            <p className="footer__tagline">{t("footer.brand.tagline")}</p>

            <div
              className="footer__socials"
              aria-label={t("footer.socials.aria")}
            >
              <a
                className="social-icon"
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.facebook")}
              >
                <FaFacebookF aria-hidden="true" />
              </a>
              <a
                className="social-icon"
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.instagram")}
              >
                <FaInstagram aria-hidden="true" />
              </a>
              <a
                className="social-icon"
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.whatsapp")}
              >
                <FaWhatsapp aria-hidden="true" />
              </a>
            </div>
          </div>
          <nav className="footer__col" aria-label={t("footer.brands.aria")}>
            <h4 className="footer__title">
              {t("footer.brands.titleLine1")}
              <br />
              {t("footer.brands.titleLine2")}
            </h4>

            <ul className="footer__list">
              <li>
                <a
                  className="footer__link"
                  href="https://deko.gruposantamaria.cr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Deko
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://rollerup.gruposantamaria.cr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Roller Up
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://dreamon.gruposantamaria.cr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Dream On
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://sofa.gruposantamaria.cr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  The Sofa Factory
                </a>
              </li>
              <li>
                <a
                  className="footer__link"
                  href="https://textiles.gruposantamaria.cr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Textiles Santamaría
                </a>
              </li>
            </ul>
          </nav>

          <div className="footer__col" aria-label={t("footer.showrooms.aria")}>
            <h4 className="footer__title">{t("footer.showrooms.title")}</h4>

            <ul className="footer__list footer__list--showrooms">
              {locations.map((loc) => (
                <li key={loc.id} className="footer__showroom-item">
                  <span className="footer__showroom-name">{loc.title}</span>
                  <span className="footer__showroom-phone">{loc.phone}</span>

                  <a
                    className="footer__waze"
                    href={wazeFrom(loc)}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={t("footer.showrooms.wazeTitle", {
                      title: loc.title,
                    })}
                    aria-label={t("footer.showrooms.wazeAria", {
                      title: loc.title,
                    })}
                  >
                    <SiWaze aria-hidden="true" />
                    <span>{t("footer.showrooms.howToGet")}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <address
            className="footer__col footer__contact"
            aria-label={t("footer.contact.aria")}
          >
            <h4 className="footer__title">{t("footer.contact.title")}</h4>
            <ul className="footer__list">
              <li className="footer__contact-row">
                <span className="icon">
                  <FiMail aria-hidden="true" />
                </span>
                <a className="footer__link" href={`mailto:${email}`}>
                  {email}
                </a>
              </li>

              <li className="footer__contact-row">
                <span className="icon">
                  <FiPhone aria-hidden="true" />
                </span>
                <a className="footer__link" href={toTelHref(phone)}>
                  {phone}
                </a>
              </li>

              <li className="footer__contact-row">
                <span className="icon">
                  <FiMapPin aria-hidden="true" />
                </span>
                <span>{country}</span>
              </li>

              <li className="footer__contact-row">
                <span className="icon" aria-hidden="true">
                  •
                </span>
                <Link className="footer__link" to="/contact">
                  {t("footer.contact.contactLink")}
                </Link>
              </li>
            </ul>
          </address>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {new Date().getFullYear()} {t("footer.bottom.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
